import { render, staticRenderFns } from "./chooseKpi.vue?vue&type=template&id=4da1bc09&scoped=true&"
import script from "./chooseKpi.vue?vue&type=script&lang=js&"
export * from "./chooseKpi.vue?vue&type=script&lang=js&"
import style0 from "./chooseKpi.vue?vue&type=style&index=0&id=4da1bc09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da1bc09",
  null
  
)

export default component.exports